<template>
  <div class="p-menus-no-plan sm_container">
    <!-- ライフ -->
    <LoadingContent v-if="isLoading" />
    <template v-else>
      <div
        v-if="pageTotal"
        class="p-menus-no-plan__paginator p-menus-no-plan__paginator--header sm_paginatorH"
        :class="{ 'p-menus-no-plan__paginator--empty': planList.length === 0 }"
      >
        <Paginator :total="pageTotal" :totalFontSizeSP="13" :totalNumFontSizeSP="13" :paginatorAvailable="false"  @pageChange="pageChange"/>

        <!-- TODO: 次回フェーズで使用する可能性があるため、コメントアウト -->
        <!-- <div>
          <option value="" selected hidden>並べ替え</option>
          <option v-for="sortItem in sortList" :value="sortItem.value" :key="sortItem">
            {{ sortItem.label }}
          </option>
        </div> -->
      </div>

      <!-- プランが0件の場合 -->
      <div
        v-if="planList.length === 0 || menuType === 10"
        class="p-menus-no-plan__noPlan sm_noPlan"
      >
        <p>現在、ご利用いただけるプランがありません。</p>
      </div>

      <!-- プランが存在する場合 -->
      <ul v-if="Object.keys(this.planList).length > 0 && menu.menuBasicInfo">
        <li v-for="(item, index) in planList" :key="index">
          <!--  興行    -->
          <template
            v-if="
              menu.menuBasicInfo.srvicDiv == CONST_DATA.SRVIC_DIV.ENTERTAINMENT &&
                getRecommendationPlanData(item)
            "
          >
            <MenusExhibition
              :menuNo="queryCode.menuNo"
              :plan="item"
              :recommendationPlanData="getRecommendationPlanData(item)"
              :seatType="getSeatType(item)"
              :iconCd="item.planIcons[0].iconCd"
            />
          </template>

          <!--  興行以外    -->
          <template v-else>
            <MenusPlanBlock
              :menu="menu"
              :menuNo="queryCode.menuNo"
              :plan="item"
              :planDetails="planListDetails[index]"
              :usageDiv="usageDiv"
            />
          </template>
        </li>
      </ul>

      <!-- ページネーション -->
      <div
        v-if="pageTotal"
        class="p-menus-no-plan__paginator p-menus-no-plan__paginator--footer sm_paginatorF"
        :class="{ 'p-menus-no-plan__paginator--empty': planList.length === 0 }"
      >
        <PaginatorCenter :total="pageTotal" :totalFontSizeSP="13" :totalNumFontSizeSP="13" @pageChange="pageChange" />
      </div>
    </template>

    <!--  公演情報  -->
    <MenusConcertInfoTable
      :menu="menu"
      :planList="planList"
      v-if="menu && menu.menuBasicInfo && menu.menuBasicInfo.srvicDiv == CONST_DATA.SRVIC_DIV.ENTERTAINMENT"
    />
  </div>
</template>

<script>
import _ from 'lodash'
import get from "lodash/get"
import  Paginator  from '../components/Paginator'
import  PaginatorCenter  from '../components/PaginatorCenter'
import MenusPlanBlock from '../../components/MenusPlanBlock'
export default {
  components: {
    Paginator,
    PaginatorCenter,
    MenusPlanBlock
  },
  props: {
    menu: {
      type: Object,
      default: () => null
    },
    menuType: {
      type: Boolean,
      default: true
    }
  },
 
  data() {
    return {
      planList: [],
      planListDetails: [],
      pageTotal: 0,
      currentPage: 1,
      isLoading: false,
      RecommendationPlanDataList: [],
    };
  },
  computed: {
    queryCode() {
      return {
        catExl: this.$route.params.catExl
          ? this.$route.params.catExl.replace("catExl=", "")
          : "",
        catLrg: this.$route.params.catLrg
          ? this.$route.params.catLrg.replace("catLrg=", "")
          : "",
        catMid: this.$route.params.catMid
          ? this.$route.params.catMid.replace("catMid=", "")
          : "",
        catSml: this.$route.params.catSml
          ? this.$route.params.catSml.replace("catSml=", "")
          : "",
        menuNo: this.$route.params.menuNo
          ? this.$route.params.menuNo.replace("menuNo=", "")
          : "",
        planId: this.$route.params.planId
          ? this.$route.params.planId.replace("planId=", "")
          : ""
      };
    },
    usageDiv(){
      return _.get(this.menu, 'headerData.usageDiv[0]', 0)
    },
    menuHeaderData() {
      if (!this.menu || !this.menu.headerData) return {};
      return this.menu.headerData;
    }
  },
  methods: {
    async fetch() {
      this.isLoading = true;

      if(this.menu && Object.keys(this.menu).length) {
        // API実行エラーの場合
        // currentPageの設定
        let uri = window.location.href.split('?');
        let currPage = this.currentPage;
        if(uri.length == 2) {
          let vars = uri[1].split('&');
          let tmp = '';
          vars.forEach(function(v) {
            tmp = v.split('=');
            if(tmp.length == 2 && tmp[0] == "page" && !isNaN(tmp[1]))
              currPage = Number(tmp[1]);
          });
        }
        // 取得したプラン情報を設定
        // ※アイコン表示可否を確認してフラグを付与する
        let tempPlanList = this.menu.plans || [];
        const numberOfItems = 10;
        if (tempPlanList.length > 0) {
          var startIndex = (currPage - 1) * numberOfItems;
          tempPlanList = tempPlanList.slice(startIndex, startIndex + numberOfItems);
        }
    
        this.planList = tempPlanList.map((x) => {
          let obj = null;
          if (x.planIcons) {
            obj = {
              ...x,
              planIcons: x.planIcons.map((y) => {
                return {
                  ...y,
                  isAvailable: this.$menuIcons.isAvailable(
                    y.iconCd,
                    this.$auth.loggedIn,
                    true,
                    this.$route
                  )
                };
              })
            };
          } else {
            obj = { ...x };
          }
          return obj;
        });
        // planDetailsが0件もしくはnullの場合は空配列を返す
        if (!this.menu || !this.menu.planDetails || !this.menu.planDetails.length) {
          this.planListDetails = [];
        } else {
          this.planListDetails = get(this.menu, 'planDetails', []);
        }

        this.pageTotal = this.menu?.plans?.length || 0;

        // meta設定
        this.$meta.setDocumentTitle(`メニュー「${this.menuHeaderData.menuNm}」（プラン一覧）`)

        // 価格・ベネポ表示用データの一覧を設定
        this.RecommendationPlanDataList = this.menu.planDetails || [];

        this.isLoading = false;
      }
    },
    pageChange(page) {
      this.currentPage = page;
    },
    getRecommendationPlanData(data) {
      let targetData = null;
      if (data && data.planBasicInfo && data.planBasicInfo.planId) {
        targetData = this.RecommendationPlanDataList.find(
          (v) => v.planId === data.planBasicInfo.planId
        );
      }

      if (
        targetData &&
        targetData.generalPrice &&
        targetData.alliancePrice &&
        targetData.pyrlDedDiscount &&
        targetData.benepoReturnInfo &&
        targetData.benepoReturnInfo.benepoReturnDiv &&
        targetData.benepoReturnInfo.benepoReturnRate &&
        targetData.benepoReturnInfo.benepoReturnFixed
      ) {
        return {
          price: targetData.price,
          generalPrice: targetData.generalPrice,
          alliancePrice: targetData.alliancePrice,
          pyrlDedDiscount: targetData.pyrlDedDiscount,
          benepoReturnInfo: {
            benepoReturnDiv: targetData.benepoReturnInfo.benepoReturnDiv,
            benepoReturnRate: targetData.benepoReturnInfo.benepoReturnRate,
            benepoReturnFixed: targetData.benepoReturnInfo.benepoReturnFixed
          }
        };
      }
      return null;
    },
    getSeatType(data) {
      let targetData = null;
      if (data && data.planBasicInfo && data.planBasicInfo.planId) {
        targetData = this.RecommendationPlanDataList.find(
          (v) => v.planId === data.planBasicInfo.planId
        );
      }

      if (
        targetData &&
        targetData.ticketHeading &&
        targetData.ticketHeading.seatType
      ) {
        return targetData.ticketHeading.seatType;
      }
      return "";
    }
  },
  async mounted() {
    // this.$emit("currentTab", this.$enums.menu.PLAN);
    await this.fetch();
  },
  watch: {
    $route() {
      this.fetch();
    },
    menu() {
      this.fetch();
      this.$meta.setDocumentTitle(
        `メニュー「${this.menuHeaderData.title}」（プラン一覧）`
      );
    }
  }
};
</script>

<style lang="scss" scoped>
@import './styles.scss';


@media screen and (max-width: $contentWidthS) {
  .sm {
    &_container {
      background-color: #ffffff;
    }
    &_paginatorH {
      box-shadow: none;
      padding: 0;
    }
    &_noPlan {
      padding: 32px 0;
      font-size: 13px;
      font-weight: 400;
      color: #1F2021;
      p {
        margin-bottom: 0;
      }
    }
    &_paginatorF {
      box-shadow: none;
      padding: 0;
    }
  }
}


</style>

<style lang="scss" >
.p-menus-no-plan{
  box-shadow: 0 1px 8px rgba(0,0,0,.08);
}
.p-menu-plan-block__contents{
  width: 100% !important;
 
  .c-button__secondary--color2 {
      border-color: #434547;
      background-color: #fff;
    }
    .c-button__secondary {
      padding: 8px 12px;
      font-size: .875rem;
      font-weight: 700;
      border: 1px solid; 
      border-radius: 6px;
      position: relative;
      display: inline-block;
      line-height: 1.25;
      text-align: center;
      cursor: pointer;
      color: #1f2021;
      }
    .c-button__secondary:hover{
      background-color: #f4f5f6;
      color: #1f2021;
    }
}
</style>
